<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
      <div class="mb-2 p-2 border-bottom border-light">
        <h5 class="font-weight-light">
          <span><i class="fa-light fa-pen-to-square fa-lg"></i></span>
          Editar Senha
        </h5>
      </div>
      <Loading v-if="isLoading" class="loading" loadingText="Carregando..." />
      <div v-else>
        <b-form v-if="edit_user.length == 0">
          <b-form-row>
            <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
              <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
              <b-input-group>
                <b-form-input size="sm" type="text" placeholder="ID" v-model.trim="tempIdUsuario"
                  @input="updateIdUsuario"></b-form-input>
                <b-input-group-append class="append">
                  <i class="fa-regular fa-user"></i>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
              <label for="input-idUser">Senha: <span class="text-danger">*</span></label>
              <b-input-group>
                <b-form-input size="sm" :type="typeInput" v-model.trim="senha" @input="updateIdUsuario"
                  class="w-75"></b-form-input>
                <b-input-group-append @click="showPassword" class="append show-password">
                  <i :class="typeInput === 'password' ? 'fa-regular fa-eye icon' : 'fa-regular fa-eye-slash icon'"></i>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12" md="12" lg="4"
              class="mt-2 mt-lg-3 d-flex align-items-center justify-content-center justify-content-lg-start">
              <b-button size="sm" class="shadow-none btn btn-primary border-primary"
                @click="pos_edit_user()">Confirmar</b-button>
            </b-col>
          </b-form-row>
        </b-form>
        <b-form v-else>
          <b-form-row>
            <b-col cols="12" md="4" class="mt-2 mt-lg-3 form-group">
              <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
              <b-input-group>
                <b-form-input size="sm" type="text" placeholder="ID" v-model.trim="tempIdUsuario"
                  @input="updateIdUsuario"></b-form-input>
                <b-input-group-append class="append">
                  <i class="fa-regular fa-user"></i>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12" md="4" class="mt-2 mt-lg-3 form-group">
              <label for="input-idUser">Senha: <span class="text-danger">*</span></label>
              <b-input-group>
                <b-form-input size="sm" :type="typeInput" v-model.trim="senha" @input="updateIdUsuario"
                  class="w-75"></b-form-input>
                <b-input-group-append @click="showPassword" class="append show-password">
                  <i :class="typeInput === 'password' ? 'fa-regular fa-eye icon' : 'fa-regular fa-eye-slash icon'"></i>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12" md="4"
              class="mt-2 mt-lg-3 d-flex align-items-center justify-content-center justify-content-lg-start">
              <b-button size="sm" class="shadow-none btn btn-primary border-primary"
                @click="pos_edit_user()">Confirmar</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';
export default {
  name: 'edit-user',
  components: { Loading: () => import('@/components/loading.vue') },
  data() {
    return {
      isLoading: false,

      edit_user: [], //289439
      idUsuario: '',
      senha: '',

      tempIdUsuario: '',
      typeInput: '',

      fields: [
        { key: 'id', label: 'ID', class: 'text-center', tdAttr: { style: 'width: 10%' } },
        { key: 'message', label: 'Mensagem', tdAttr: { style: 'width: 40%' } },
        { key: 'activated', label: 'Status', class: 'text-center', tdAttr: { style: 'width: 5%' } },
        { key: 'error', label: '', tdAttr: { style: 'width: 45%' } },
      ],
    };
  },
  created() {
    this.showPassword();
  },
  async mounted() {
    if (this.$route.query.loading) {
      this.isLoading = true;
      try {
        await this.fetchData();
      } catch (error) {
        console.error("ERROR loading data: ", error)
      } finally {
        this.isLoading = false
      }
    }
  },
  methods: {
    async fetchData() {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    },
    showPassword() {
      this.typeInput = this.typeInput === 'password' ? 'text' : 'password'
    },

    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    pos_edit_user() {
      this.isLoading = true;
      this.idUsuario = this.tempIdUsuario;

      ApiService.get('v1/callAlterarSenha', {
        idUsuario: this.idUsuario,
        senha: this.senha,
      })
        .then((response) => {
          this.edit_user = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;

          // this.spiner = false;
        });
    },

    updateIdUsuario(event) {
      // Pegue o valor do input
      let inputValue = event.target.value;

      // Remova caracteres não numéricos
      let cleanValue = inputValue.replace(/[^\d]/g, '');

      // Atualize o valor
      this.tempIdUsuario = cleanValue;
    },
  },
  computed: {
    mensagemModificada() {
      const alterarSenha = this.edit_user?.data?.AlteraSenhaUsuario?.xml
      if (alterarSenha && alterarSenha.status?.msg === 'Consulta efetuada com sucesso!') {
        return 'Senha alterada com sucesso!'
      }

      return alterarSenha?.status?.msg || '-'
      // if (
      //   this.edit_user &&
      //   this.edit_user.data.AlteraSenhaUsuario.xml.status.msg === 'Consulta efetuada com sucesso!'
      // ) {
      //   return 'A senha foi trocada!';
      // }
      // return this.edit_user.data.AlteraSenhaUsuario.xml.status.msg; // Retorne a mensagem original se não for a que queremos substituir
    },
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
    formattedData() {
      if (!this.edit_user.data || !this.edit_user.data.AlteraSenhaUsuario) {
        return [];
      }

      const alterarSenha = this.edit_user.data.AlteraSenhaUsuario;

      if (alterarSenha && typeof alterarSenha === 'object') {
        return [{
          idUsuario: this.idUsuario,
          status: alterarSenha.status,
          erro: alterarSenha.erro,
          msg: alterarSenha.msg || 'Mensagem não disponível!'
          // mensagem: alterarSenha.msg,
          // saldo: creditoUsuario.xml?.dados?.saldo,
        }];
      }

      console.log('Dados formatados: ', data)
      return [];
    },
  },
};
</script>

<style scoped>
.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

.loading {
  height: 25vh;
}
</style>
